const design = {
    "ui": [
        {
            "name":"Pinterest",
            "img": "",
            "thumbnail": "pinterest.svg",
            "link":"https://www.pinterest.com/",
            "hint": ""
        },
        {
            "name":"Dribbble",
            "img": "",
            "thumbnail": "dribbble.svg",
            "link":"https://dribbble.com/",
            "hint": ""
        } ,
        {
            "name":"calltoidea",
            "img": "",
            "thumbnail": "callToIdea.svg",
            "link":"http://www.calltoidea.com/",
            "hint": ""
        },
        {
            "name":"ui-patterns",
            "img": "",
            "thumbnail": "uiPatern.svg",
            "link":"http://ui-patterns.com/",
            "hint": ""
        } ,
        {
            "name":"SectionSeparators",
            "img": "",
            "thumbnail": "sep.svg",
            "link":"https://tympanus.net/Development/SectionSeparators/",
            "hint": ""
        },
        {
            "name":"mediaqueri",
            "img": "",
            "thumbnail": "mq.svg",
            "link":"https://mediaqueri.es/",
            "hint": ""
        },
        {
            "name":"OnePageLove",
            "img": "",
            "thumbnail": "onePageLove.svg",
            "link":"https://onepagelove.com/",
            "hint": ""
        },
        {
            "name":"siteinspire",
            "img": "",
            "thumbnail": "siteInspire.svg",
            "link":"https://www.siteinspire.com/",
            "hint": ""
        },
        {
            "name":"land-book",
            "img": "",
            "thumbnail": "landBook.svg",
            "link":"https://land-book.com/",
            "hint": ""
        }

    ],
    "colors": [
        {
            "name":"discovercolor",
            "img": "",
            "thumbnail": "discoverColor.svg",
            "link":"http://discovercolor.ru",
            "hint": ""
        },
        {
            "name":"paletton",
            "img": "",
            "thumbnail": "paletton.svg",
            "link":"http://paletton.com/",
            "hint": ""
        },
        {
            "name":"materialpalette",
            "img": "",
            "thumbnail": "matDesColor.svg",
            "link":"https://www.materialpalette.com/",
            "hint": ""
        },
        {
            "name":"flatuicolors",
            "img": "",
            "thumbnail": "flatUi.svg",
            "link":"https://flatuicolors.com/",
            "hint": ""
        },
        {
            "name":"colorrrs",
            "img": "",
            "thumbnail": "colorrrs.svg",
            "link":"https://www.webpagefx.com/web-design/random-color-picker/",
            "hint": ""
        },
        {
            "name":"uigradients",
            "img": "",
            "thumbnail": "uiGradient.svg",
            "link":"https://uigradients.com/#Stellar",
            "hint": ""
        },
        {
            "name":"color-wheel",
            "img": "",
            "thumbnail": "colorCircle.svg",
            "link":"https://color.adobe.com/ru/create/color-wheel/",
            "hint": ""
        },
        {
            "name":"0-255",
            "img": "",
            "thumbnail": "0to255.svg",
            "link":"http://www.0to255.com/",
            "hint": ""
        },{
            "name":"colorhunt",
            "img": "",
            "thumbnail": "colorHunt.svg",
            "link":"http://www.colorhunt.co/c/",
            "hint": ""
        },
        {
            "name":"а-я",
            "img": "",
            "thumbnail": "colorsName.svg",
            "link":"http://colorscheme.ru/color-names.html",
            "hint": ""
        }

    ],
    "backgrounds":[
        {
            "name":"placeit",
            "img": "",
            "thumbnail": "404.svg",
            "link":"https://placeit.net/",
            "hint": ""
        },
        {
            "name":"randomuser",
            "img": "",
            "thumbnail": "404.svg",
            "link":"https://randomuser.me/",
            "hint": ""
        },  
        {
            "name":"Subtle Patterns",
            "img": "",
            "thumbnail": "subPatern.svg",
            "link":"http://subtlepatterns.com/",
            "hint": ""
        },  
        {
            "name":"patterncooler",
            "img": "",
            "thumbnail": "freeSeamlessPatern.svg",
            "link":"https://patterncooler.com/",
            "hint": ""
        },  
        {
            "name":"patterninja",
            "img": "",
            "thumbnail": "patterninja.svg",
            "link":"https://patterninja.com/",
            "hint": ""
        },  
        {
            "name":"colourlovers",
            "img": "",
            "thumbnail": "colorTrends.svg",
            "link":"http://www.colourlovers.com/",
            "hint": ""
        },
        {
            "name":"canva",
            "img": "",
            "thumbnail": "canva.svg",
            "link":"https://www.canva.com/",
            "hint": ""
        },
        {
            "name":"Img64",
            "img": "",
            "thumbnail": "404.svg",
            "link":"https://www.base64-image.de",
            "hint": ""
        },
        
    ],
    "images":[
        {
            "name":"pixabay",
            "img": "",
            "thumbnail": "pixabay.svg",
            "link":"https://pixabay.com/en/",
            "hint": ""
        },
        {
            "name":"freeimages",
            "img": "",
            "thumbnail": "freeImg.svg",
            "link":"http://www.freeimages.com/",
            "hint": ""
        },
        {
            "name":"foter",
            "img": "",
            "thumbnail": "foter.svg",
            "link":"http://foter.com/",
            "hint": ""
        },      
        {
            "name":"StockSnap",
            "img": "",
            "thumbnail": "stockSnap.svg",
            "link":"https://stocksnap.io/",
            "hint": ""
        },      
        {
            "name":"theStocks",
            "img": "",
            "thumbnail": "theStock.svg",
            "link":"http://thestocks.im/",
            "hint": ""
        },      
        {
            "name":"Start up stock",
            "img": "",
            "thumbnail": "startUpStock.svg",
            "link":"http://startupstockphotos.com/",
            "hint": ""
        },      
        {
            "name":"ISO republic",
            "img": "",
            "thumbnail": "iso.svg",
            "link":"http://isorepublic.com/",
            "hint": ""
        },      
        {
            "name":"openphoto",
            "img": "",
            "thumbnail": "curated.svg",
            "link":"http://openphoto.net/",
            "hint": ""
        },      
        {
            "name":"Unsplash",
            "img": "",
            "thumbnail": "unsplash.svg",
            "link":"https://unsplash.com/",
            "hint": ""
        },      
        {
            "name":"flickr",
            "img": "",
            "thumbnail": "flicker.svg",
            "link":"https://www.flickr.com/",
            "hint": ""
        },      
        {
            "name":"coverr",
            "img": "",
            "thumbnail": "coverr.svg",
            "link":"http://www.coverr.co/",
            "hint": ""
        },
        {
            "name":"pexels",
            "img": "",
            "thumbnail": "pexels.svg",
            "link":"https://www.pexels.com/",
            "hint": ""
        },      
        {
            "name":"iStockPhoto",
            "img": "",
            "thumbnail": "is.svg",
            "link":"http://www.istockphoto.com/",
            "hint": ""
        }
    ],
    "fonts":[
        {
            "name":"Google Fonts",
            "img": "",
            "thumbnail": "fontGoogle.svg",
            "link":"https://www.google.com/fonts",
            "hint": ""
        },
        {
            "name":"webmasters",
            "img": "",
            "thumbnail": "404.svg",
            "link":"http://webmasters.teamdev.com/",
            "hint": ""
        },
        {
            "name":"font-generator",
            "img": "",
            "thumbnail": "freeFont.svg",
            "link":"http://brandmark.io/font-generator/",
            "hint": ""
        },
        {
            "name":"Русские шрифты",
            "img": "",
            "thumbnail": "ruFonts.svg",
            "link":"http://fonts4web.ru/",
            "hint": ""
        },
        {
            "name":"Font Squirrel",
            "img": "",
            "thumbnail": "fontSquirrel.svg",
            "link":"https://www.fontsquirrel.com/",
            "hint": ""
        },
        {
            "name":"topcoat",
            "img": "",
            "thumbnail": "404.svg",
            "link":"http://topcoat.io/",
            "hint": ""
        },
        
        
    ],

    "icons": [
        {
            "name":"Free vector icon",
            "img": "",
            "thumbnail": "fvi.svg",
            "link":"https://www.flaticon.com/",
            "hint": ""
        },
        {
            "name":"Icons for Everything",
            "img": "",
            "thumbnail": "nounProject.svg",
            "link":"https://thenounproject.com/",
            "hint": ""
        },
        {
            "name":"Linea Free Iconset",
            "img": "",
            "thumbnail": "leneaIcon.svg",
            "link":"http://linea.io/",
            "hint": ""
        },
        {
            "name":"Feather icons",
            "img": "",
            "thumbnail": "featherIcon.svg",
            "link":"https://feathericons.com/",
            "hint": ""
        },
        {
            "name":"proto",
            "img": "",
            "thumbnail": "protoIcon.svg",
            "link":"https://proto.io/freebies/onoff/",
            "hint": ""
        },
        {
            "name":"Icon jar",
            "img": "",
            "thumbnail": "iconJar.svg",
            "link":"https://geticonjar.com/",
            "hint": ""
        },
        {
            "name":"Iconmonstr",
            "img": "",
            "thumbnail": "iconMonstr.svg",
            "link":"https://iconmonstr.com/",
            "hint": ""
        },
        {
            "name":"Swift icons",
            "img": "",
            "thumbnail": "swiftIcon.svg",
            "link":"https://www.swifticons.com/",
            "hint": ""
        },
        {
            "name":"Icons8",
            "img": "",
            "thumbnail": "icons8.svg",
            "link":"https://icons8.com/",
            "hint": ""
        },
        {
            "name":"fontastic",
            "img": "",
            "thumbnail": "fontastic.svg",
            "link":"http://fontastic.me/",
            "hint": ""
        },
        {
            "name":"icoMoon",
            "img": "",
            "thumbnail": "iconMoon.svg",
            "link":"https://icomoon.io/app/#/select/library",
            "hint": ""
        },
        {
            "name":"Font Awesome",
            "img": "",
            "thumbnail": "fontAwesome.svg",
            "link":"http://fontawesome.ru/all-icons/",
            "hint": "deprecated"
        }
    ],
    "validate": [
    	{
            "name":"colorfilter",
            "img": "",
            "thumbnail": "colorBlindFilter.svg",
            "link":"https://www.toptal.com/designers/colorfilter",
            "hint": ""
        },
        {
            "name":"validator",
            "img": "",
            "thumbnail": "w3c.svg",
            "link":"http://validator.w3.org/",
            "hint": ""
        },
        {
            "name":"webaim",
            "img": "",
            "thumbnail": "wave.svg",
            "link":"http://wave.webaim.org/",
            "hint": ""
        }
    ]

}


export default design;


// WEBPACK FOOTER //
// ./src/assets/db/design.js